import * as z from "zod";

/** A team's marketing analytics settings. `includeBotClicks` decides whether
 *  bot clicks count, in click metrics and as attribution evidence. */
export const marketingAnalyticsSettingsSchema = z.object({
  includeBotClicks: z.boolean(),
});
export type MarketingAnalyticsSettings = z.infer<
  typeof marketingAnalyticsSettingsSchema
>;

export const DEFAULT_MARKETING_ANALYTICS_SETTINGS: MarketingAnalyticsSettings =
  { includeBotClicks: true };
